import { withAppCrashIfException } from 'epic';
import { loadAfterTabContentFetchedEpic } from 'epic/secondaryMarket/quotesWorkspace/loadAfterTabContentFetchedEpic';
import { persistLimitOrderTabContentEpic } from 'epic/secondaryMarket/quotesWorkspace/persistLimitOrderTabContentEpic';
import { triggerLimitOrderTabContentPersistenceEpic } from 'epic/secondaryMarket/quotesWorkspace/triggerLimitOrderTabContentPersistenceEpic';
import { combineEpics } from 'redux-observable';
import { limitOrderInputFormSelectors } from 'state/secondaryMarket/limit-order/form/input/inputForm.selectors';
import { limitOrderThunks } from 'state/secondaryMarket/limit-order/limitOrder.thunk';
import { liveThunks } from 'state/secondaryMarket/live/live.thunk';

import { clearTabContentEpic } from './clearTabContentEpic';
import { enterWorkspaceEpic } from './enterWorkspaceEpic';
import { fetchSecondaryQuoteWorkspaceTabsEpic } from './fetchSecondaryMarketQuoteWorkspaceTabsEpic';
import { loadAfterCpOrderTabContentFetchedEpic } from './loadAfterCpOrderTabContentFetchedEpic';
import { persistCpOrderTabContentEpic } from './persistCpOrderTabContentEpic';
import { persistLiveTabContentEpic } from './persistLiveTabContentEpic';
import { triggerCpOrderTabContentPersistenceEpic } from './triggerCpOrderTabContentPersistenceEpic';
import { triggerLiveTabContentPersistenceEpic } from './triggerLiveTabContentPersistenceEpic';
export const secondaryMarketQuotesWorkspaceEpic = () =>
  withAppCrashIfException(
    'secondaryMarketQuotesWorkspace',
    combineEpics(
      withAppCrashIfException('clearTabContentEpic', clearTabContentEpic()),
      withAppCrashIfException('enterWorkspaceEpic', enterWorkspaceEpic()),
      withAppCrashIfException('fetchSecondaryQuoteWorkspaceTabsEpic', fetchSecondaryQuoteWorkspaceTabsEpic()),
      withAppCrashIfException('loadAfterCpOrderTabContentFetchedEpic', loadAfterCpOrderTabContentFetchedEpic()),
      withAppCrashIfException(
        'loadAfterLiveTabContentFetchedEpic',
        loadAfterTabContentFetchedEpic('live', liveThunks.reloadTabThunk),
      ),
      withAppCrashIfException(
        'loadAfterLimitOrderTabContentFetchedEpic',
        loadAfterTabContentFetchedEpic('limitOrder', limitOrderThunks.reloadTabThunk),
      ),
      withAppCrashIfException('persistCpOrderTabContentEpic', persistCpOrderTabContentEpic()),
      withAppCrashIfException('persistLiveTabContentEpic', persistLiveTabContentEpic()),
      withAppCrashIfException('persistLimitOrderTabContentEpic', persistLimitOrderTabContentEpic()),
      withAppCrashIfException('triggerCpOrderTabContentPersistenceEpic', triggerCpOrderTabContentPersistenceEpic()),
      withAppCrashIfException('triggerLiveTabContentPersistenceEpic', triggerLiveTabContentPersistenceEpic()),
      withAppCrashIfException(
        'triggerLimitOrderTabContentPersistenceEpic',
        triggerLimitOrderTabContentPersistenceEpic(limitOrderInputFormSelectors.getFormTabContentToPersist),
      ),
    ),
  );
